import React, { FC } from 'react';
import { Chip } from '@mui/material';

interface CategoryTagsComponentProps {
    categories: string[] | null | undefined,
    tagLimit?: number,
}

const CategoryTagsComponent: FC<CategoryTagsComponentProps> = (props) => {
    const { categories, tagLimit } = props;

    if (!categories) {
        return null;
    }

    return (
        <>
            {([...categories].sort().map((c, i) => (i < (tagLimit ?? 2)
                ? <Chip label={c} key={c} size="small" sx={{ mr: 1 }} /> : null)))}
            {categories.length > (tagLimit ?? 2) ? (
                <Chip label={`+${categories.length - (tagLimit ?? 2)}`} size="small" sx={{ mr: 1 }} />) : null}
        </>
    );
};

export default CategoryTagsComponent;

CategoryTagsComponent.defaultProps = {
    tagLimit: 2,
};
